import { shortShape } from "./common";

export const userShortShape = shortShape;
